<template>
  <div>
    <div class="section">
      <h3 class="section-title">
        <span class="step">
          1
        </span>
        IMPORTÁLÁS BEÁLLÍTÁSOK
      </h3>
      <div class="section-content">
        <div class="col-12">
          <div class="row">
            <div class="col-6 form-group">
              <label for="encoding">Karakterkészlet</label>
              <select
                id="encoding"
                v-model="settings.encoding"
                class="form-control"
                name="encoding"
              >
                <option value="UTF-8">
                  UTF-8
                </option>
                <option value="ISO-8859-2">
                  ISO 8859-2
                </option>
                <option value="ISO-8859-1">
                  ISO 8859-1
                </option>
              </select>
            </div>
            <div class="col-6 form-group">
              <label for="separator">Adatmező elválasztó jel</label>
              <select
                id="separator"
                v-model="settings.separator"
                class="form-control"
                name="separator"
              >
                <option
                  v-for="(sep, index) in separators"
                  :key="index"
                  :value="sep.value"
                >
                  {{ sep.text }}
                </option>
              </select>
            </div>
            <div class="col-12 form-group">
              <date-format-selector
                v-model="settings.date_format"
                name="date_format"
                label="Dátum formátum"
                :suggestions="suggestions"
                :values="valuesProp.date_formats"
              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <div class="form-check">
              <input
                id="gridCheck"
                v-model="settings.has_header"
                class="form-check-input"
                type="checkbox"
              >
              <label
                class="form-check-label"
                for="gridCheck"
              >
                Fejlécet tartalmaz az adatbázis
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <h3 class="section-title">
        <span class="step">
          2
        </span>
        ELŐNÉZET ÉS ADATPÁROSÍTÁS
      </h3>
      <div class="section-content">
        <div class="section">
          <h4 class="section-title">
            Előnézet
          </h4>
          <import-preview
            class="section-content"
            :rows="rows"
            :has-header="settings.has_header"
          />
        </div>
        <div class="section">
          <h4 class="section-title">
            Adatpárosítás
          </h4>
          <div class="section-content">
            <column-association
              v-if="rows.length > 1"
              v-model="settings.column_association"
              :rows="rows"
              :has-header="settings.has_header"
              :errors="errors"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 mt-3 d-flex">
        <a class="btn btn-secondary mr-auto" :href="$url('imports.index')">
          <i class="fas fa-arrow-left"></i> Vissza az importálásokhoz
        </a>
        <button
          class="btn btn-info"
          :disabled="hasError"
          @click="saveSettings"
        >
            Tovább a feldolgozáshoz <i class="fas fa-arrow-right"></i>
        </button>
    </div>
  </div>
</template>
<style>

</style>
<script>
import ImportPreview from './ImportPreview'
import ColumnAssociation from './ColumnAssociation'
import DateFormatSelector from './DateFormatSelector'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

export default {
  mixins: [
    ErrorHandler()
  ],
  components: {
    ImportPreview,
    ColumnAssociation,
    DateFormatSelector
  },
  props: {
    importProp: {
      type: Object,
      default: () => ({
        id: -1,
        encoding: '',
        separator: '',
        has_header: false,
        date_format: '',
        file_name: '',
        column_association: {}
      })
    },
    valuesProp: {
      type: Object,
      default: () => ({
        date_formats: []
      })
    }
  },
  data() {
    return {
      rows: [],
      suggestions: {},
      settings: {
        has_header: false,
        encoding: '',
        separator: '',
        column_association: {},
        date_format: ''
      },
      id: -1,
      errors: {},
      saving: false,
      date_formats: [],
      separators: [{
        value: 'semicolon',
        text: 'Pontosvessző'
      }, {
        value: 'comma',
        text: 'Vessző'
      }, {
        value: 'tabulator',
        text: 'Tabulátor'
      }]
    }
  },
  computed: {
    hasError() {
      var blockingErrors = _.omit(this.errors, ['dispatched_at'])

      return _.size(blockingErrors) > 0 ||
        typeof this.settings.column_association.subject === 'undefined'
    }
  },
  watch: {
    handler$error(message) {
      if (message.length > 0) {
        window.scrollTo(0,0);
      }
    },
    settings: {
      deep: true,
      handler(settings) {
        this.clearErrors()
        this.errors = {}
        this.suggestions = {}

        this.$http.post(this.$url('api.imports.preview', this.id), settings)
          .then(({data}) => {
            var { validation, rows, suggestions } = data

            if (typeof validation !== 'undefined') {
              var { message, errors } = validation
              if (typeof message !== 'undefined') {
                this.handleError(message)
              }

              if (typeof errors !== 'undefined' && _.size(errors) > 0) {
                this.errors = _.assign(errors)
              }
            } else if (typeof rows === 'undefined') {
              this.handleError('Hiba történt az előnézet generálása közben')
              return
            }

            if (typeof suggestions !== 'undefined') {
              this.suggestions = suggestions
            }

            this.rows = rows

          }).catch(this.handleErrors)
      }
    }
  },
  mounted() {
    this.id = this.importProp.id
    this.fileName = this.importProp.file_name

    this.settings = {
      has_header: this.importProp.has_header,
      encoding: this.importProp.encoding,
      separator: this.importProp.separator,
      column_association: _.assign(this.importProp.column_association),
      date_format: this.importProp.date_format
    }

    this.date_formats = this.valuesProp.date_formats
  },
  methods: {
    saveSettings: function () {
      this.clearErrors()
      this.saving = true

      this.$store.commit('enableLoading')
      this.$http.post(this.$url('imports.save', this.id), this.settings)
        .then(({data}) => {
          if(data.success) {
            window.location.href =  this.$url('imports.success', this.id)
          } else {
            this.$store.commit('disableLoading')
            this.handleError('Hiba történt az importálás közben')
          }
        }).catch((err) => {
          this.$store.commit('disableLoading')
          this.handleErrors(err)
        }).finally(() => {
          this.saving = false
        })
    }
  }
}
</script>